const useNameComponent = (prefix: string, sufix?: string): string | null => {
  if (sufix) return prefix ? `${prefix}-${sufix}` : null;
  return prefix || null;
};

export default useNameComponent;
